import React, { Component } from 'react'


class ModalConfirm extends Component {
    state = {
        active: false
    }

    componentWillReceiveProps(props){
        this.setState({ active: props.isActive })
    }

    render() {
        const { title, children, close, confirm } = this.props
        const { active } = this.state
        const showModal = active ? ' is-active' : ''

        return (
            <div className={"modal" + showModal} style={{ zIndex: 41 }}>
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">{title}</p>
                        <button className="delete" aria-label="close" onClick={e => close(false)}></button>
                    </header>
                    <section className="modal-card-body">
                        {children}
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-success" onClick={e => confirm(false)}>Aceptar</button>
                        <button className="button" onClick={e => close(false)}>Cancelar</button>
                    </footer>
                </div>
            </div>
        )
    }
}

export default ModalConfirm


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Modal/ModalConfirm.js